import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { BaseUrl } from "../../helper/BaseUrl";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
const adddynamicEndpoint = ApiEndpoints.serviceDynamic.create;
export default function AddDynamic() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [previews, setPreviews] = useState({});
  const imageUrls = useRef([]);
  const imageFiles = useRef(new Map());
  const [postData, setPostData] = useState({
  "slug": "",
  "status": "1",
  "section1_title": "",
  "section1_description": "",
  "section1_buttonText": "",
  "section1_image": "",
  "section1_imageAlt": "",
  "section2_eyebrow": "",
  "section2_title": "",
  "section2_paragraphs": [""],
  "section2_faqs": [{
    question: "",
    answer: ""
  }, {
    question: "",
    answer: ""
  }, {
    question: "",
    answer: ""
  }],
  "section4_eyebrow": "",
  "section4_title": "",
  "section4_steps": [{
    "title": "",
    "description": ""
  }, {
    "title": "",
    "description": ""
  }, {
    "title": "",
    "description": ""
  }, {
    "title": "",
    "description": ""
  }, {
    "title": "",
    "description": ""
  }, {
    "title": "",
    "description": ""
  }],
  "section5_eyebrow": "",
  "section5_title": "",
  "section5_description": "",
  "section5_buttonText": "",
  "section5_items": [{
    "title": "",
    "description": "",
    "skills": [""]
  }, {
    "title": "",
    "description": "",
    "skills": [""]
  }, {
    "title": "",
    "description": "",
    "skills": [""]
  }, {
    "title": "",
    "description": "",
    "skills": [""]
  }, {
    "title": "",
    "description": "",
    "skills": [""]
  }, {
    "title": "",
    "description": "",
    "skills": [""]
  }],
  "section6_eyebrow": "",
  "section6_title": "",
  "section6_items": [{
    content: "",
    authorName: "",
    authorDesignation: ""
  }],
  "section7_title": "",
  "section7_button": "",
  "section7_backgroundImage": "",
  section3_title1: "",
  section3_description1: "",
  section3_title2: "",
  section3_description2: "",
  section3_eyebrow: "",
  section3_title: "",
  section3_subtitle: "",
  section3_buttonText: "",
  section3_image: ""
});
  useEffect(() => () => {
    imageUrls.current.forEach(url => URL.revokeObjectURL(url));
  }, []);
  const imagePreview = value => {
    if (value instanceof File) return imageFiles.current.get(value) || "";
    if (typeof value !== "string") return "";
    if (value.startsWith("/assets/") || value.startsWith("/images/")) return "https://catalyze.co.in" + value;
    return value.startsWith("/") ? BaseUrl.replace(/\/$/, "") + value : value;
  };
  const createPreview = (key, file) => {
    const url = URL.createObjectURL(file);
    imageUrls.current.push(url);
    imageFiles.current.set(file, url);
    setPreviews(prev => ({
      ...prev,
      [key]: url
    }));
  };
  const handleChange = event => {
    const {
      name,
      value,
      files
    } = event.target;
    const next = files ? files[0] : value;
    if (files && !next) return;
    setPostData(prev => ({
      ...prev,
      [name]: next
    }));
    if (files) createPreview(name, next);else setPreviews(prev => ({
      ...prev,
      [name]: ""
    }));
  };
  const handleEditorChange = (key, data) => {
    setPostData(prev => ({
      ...prev,
      [key]: data
    }));
  };

  // ================= SECTION 1: BANNER =================

  // ================= SECTION 2: THE GAP =================
  const handleSection2ParagraphsChange = (index, value) => {
    setPostData(prev => ({
      ...prev,
      section2_paragraphs: prev.section2_paragraphs.map((item, i) => i === index ? value : item)
    }));
  };
  const handleSection2FaqsChange = (index, field, value) => {
    setPostData(prev => ({
      ...prev,
      section2_faqs: prev.section2_faqs.map((item, i) => i === index ? {
        ...item,
        [field]: value
      } : item)
    }));
  };
  const handleAddMoreSection2Faqs = () => {
    setPostData(prev => prev.section2_faqs.length >= 100 ? prev : {
      ...prev,
      section2_faqs: [...prev.section2_faqs, {
        "question": "",
        "answer": ""
      }]
    });
  };
  const handleRemoveSection2Faqs = index => {
    if (index < 3) return;
    setPostData(prev => ({
      ...prev,
      section2_faqs: prev.section2_faqs.filter((_, i) => i !== index)
    }));
  };
  // ================= SECTION 3: CAMPUS TO CORPORATE =================

  // ================= SECTION 4: FRAMEWORK =================
  const handleSection4StepsChange = (index, field, value) => {
    setPostData(prev => ({
      ...prev,
      section4_steps: prev.section4_steps.map((item, i) => i === index ? {
        ...item,
        [field]: value
      } : item)
    }));
  };
  const handleAddMoreSection4Steps = () => {
    setPostData(prev => prev.section4_steps.length >= 100 ? prev : {
      ...prev,
      section4_steps: [...prev.section4_steps, {
  "title": "",
  "description": ""
}]
    });
  };
  const handleRemoveSection4Steps = index => {
    if (index < 6) return;
    setPostData(prev => ({
      ...prev,
      section4_steps: prev.section4_steps.filter((_, i) => i !== index)
    }));
  };
  // ================= SECTION 5: READINESS AREAS =================
  const handleSection5ItemsChange = (index, field, value) => {
    setPostData(prev => ({
      ...prev,
      section5_items: prev.section5_items.map((item, i) => i === index ? {
        ...item,
        [field]: value
      } : item)
    }));
  };
  const handleAddMoreSection5Items = () => {
    setPostData(prev => prev.section5_items.length >= 100 ? prev : {
      ...prev,
      section5_items: [...prev.section5_items, {
        "title": "",
        "description": "",
        "skills": [""]
      }]
    });
  };
  const handleRemoveSection5Items = index => {
    if (index < 6) return;
    setPostData(prev => ({
      ...prev,
      section5_items: prev.section5_items.filter((_, i) => i !== index)
    }));
  };
  // ================= SECTION 6: TESTIMONIALS =================
  const handleSection6ItemsChange = (index, field, value) => {
    setPostData(prev => ({
      ...prev,
      section6_items: prev.section6_items.map((item, i) => i === index ? {
        ...item,
        [field]: value
      } : item)
    }));
  };
  const handleAddMoreSection6Items = () => {
    setPostData(prev => prev.section6_items.length >= 100 ? prev : {
      ...prev,
      section6_items: [...prev.section6_items, {
        content: "",
        authorName: "",
        authorDesignation: ""
      }]
    });
  };
  const handleRemoveSection6Items = index => {
    setPostData(prev => ({
      ...prev,
      section6_items: prev.section6_items.filter((_, i) => i !== index)
    }));
  };
  // ================= SECTION 7: CALL TO ACTION =================

  // ================= SECTION 8: FAQS =================
  
  
  
  // ================= SUBMIT =================
  const uploadImage = async value => {
    if (!(value instanceof File)) return value;
    const formData = new FormData();
    formData.append("image", value);
    const response = await ApiRequest("POST", ApiEndpoints.serviceDynamic.upload, formData);
    return response.path;
  };
  const isFilled = value => {
    if (typeof File !== "undefined" && value instanceof File) return value.size > 0;
    if (Array.isArray(value)) return value.some(isFilled);
    return typeof value === "string" && value.replace(/<[^>]*>/g, "").replace(/&nbsp;|&#160;|&#x0*a0;/gi, " ").replace(/[\u200B-\u200D\uFEFF]/g, "").trim() !== "";
  };
  const validateForm = () => {
    if (typeof postData.slug !== "string" || postData.slug.trim() === "") return 'The field "slug" is mandatory.';
    const requiredFields = [["section1_title", " Section 1: title"], ["section1_description", " Section 1: description"], ["section1_image", " Section 1: image"], ["section1_imageAlt", " Section 1: image Alt"], ["section2_eyebrow", " Section 2: eyebrow"], ["section2_title", " Section 2: title"], ["section3_eyebrow", " Section 3: eyebrow"], ["section3_title", " Section 3: title"], ["section3_subtitle", " Section 3: subtitle"], ["section3_buttonText", " Section 3: button Text"], ["section3_image", " Section 3: image"], ["section3_title1", " Section 3: title 1"], ["section3_description1", " Section 3: description 1"], ["section3_title2", " Section 3: title 2"], ["section3_description2", " Section 3: description 2"], ["section4_eyebrow", " Section 4: eyebrow"], ["section4_title", " Section 4: title"], ["section5_eyebrow", " Section 5: eyebrow"], ["section5_title", " Section 5: title"], ["section5_description", " Section 5: description"], ["section6_eyebrow", " Section 6: eyebrow"], ["section6_title", " Section 6: title"], ["section7_title", " Section 7: title"], ["section7_backgroundImage", " Section 7: background Image"]];
    for (const [field, label] of requiredFields) if (!isFilled(postData[field])) return label + " is mandatory.";
    const requiredLists = [{
      "min": 1,
      "all": true,
      "key": "section2_paragraphs",
      "label": " Section 2: paragraphs"
    }, {
      "min": 3,
      "fields": ["question", "answer"],
      "key": "section2_faqs",
      "label": " Section 2: faqs"
    }, {
      "min": 6,
      "fields": ["title", "description"],
      "key": "section4_steps",
      "label": " Section 4: steps"
    }, {
      "min": 6,
      "fields": ["title", "description", "skills"],
      "key": "section5_items",
      "label": " Section 5: items"
    }, {
      "min": 1,
      "all": true,
      "fields": ["content", "authorName", "authorDesignation"],
      "key": "section6_items",
      "label": " Section 6: items"
    }];
    for (const rule of requiredLists) {
      const rows = postData[rule.key];
      if (!Array.isArray(rows) || rows.length < rule.min) return rule.label + " requires at least " + rule.min + " entries.";
      for (let index = 0; index < rows.length; index++) {
        const row = rows[index];
        const started = rule.fields ? Object.values(row || {}).some(isFilled) : isFilled(row);
        if (!rule.all && index >= rule.min && !started) continue;
        if (!rule.fields && !isFilled(rows[index])) return rule.label + " " + (index + 1) + " is mandatory.";
        for (const field of rule.fields || []) if (!isFilled(rows[index]?.[field])) return rule.label.trim() + " " + (index + 1) + ": " + (field === "skills" ? "Skill" : field.charAt(0).toUpperCase() + field.slice(1)) + " is mandatory.";
      }
    }
    return null;
  };
  const handleSubmit = async event => {
    event.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      toast.error(validationError);
      return;
    }
    if (!postData.section1_title.replace(/<[^>]*>/g, "").trim()) {
      toast.error("Banner title is required.");
      return;
    }
    setSaving(true);
    try {
      const payload = {
  slug: postData.slug,
  status: postData.status,
  hero: {
    title: postData.section1_title,
    description: postData.section1_description,
    buttonText: postData.section1_buttonText,
    image: await uploadImage(postData.section1_image),
    imageAlt: postData.section1_imageAlt
  },
  gap: {
    eyebrow: postData.section2_eyebrow,
    title: postData.section2_title,
    paragraphs: postData.section2_paragraphs,
    faqs: postData.section2_faqs.filter((item, index) => index < 3 || Object.values(item).some(isFilled))
  },
  campusToCorporate: {
    image: await uploadImage(postData.section3_image),
    buttonText: postData.section3_buttonText,
    subtitle: postData.section3_subtitle,
    title: postData.section3_title,
    eyebrow: postData.section3_eyebrow,
    items: [{
      title: postData.section3_title1,
      description: postData.section3_description1
    }, {
      title: postData.section3_title2,
      description: postData.section3_description2
    }]
  },
  framework: {
    eyebrow: postData.section4_eyebrow,
    title: postData.section4_title,
    steps: postData.section4_steps.filter((item, index) => index < 6 || Object.values(item).some(isFilled)).map(item => ({
      title: item.title,
      description: item.description
    }))
  },
  usp: {
    eyebrow: postData.section5_eyebrow,
    title: postData.section5_title,
    description: postData.section5_description,
    buttonText: postData.section5_buttonText,
    items: postData.section5_items.filter((item, index) => index < 6 || Object.values(item).some(isFilled))
  },
  testimonials: {
    eyebrow: postData.section6_eyebrow,
    title: postData.section6_title,
    items: postData.section6_items
  },
  readyToElevate: {
    title: postData.section7_title,
    button: postData.section7_button,
    backgroundImage: await uploadImage(postData.section7_backgroundImage)
  }
};
      const response = await ApiRequest("POST", adddynamicEndpoint, payload);
      toast.success(response.message);
      navigate("/service-dynamic-page");
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to save dynamic page.");
    } finally {
      setSaving(false);
    }
  };
  const pagename = {
    name: "Service Dynamic Page",
    user: "Admin",
    innerpage: "Service Dynamic Page / Add page"
  };
  return <>
    <AdminHeader pagename={pagename} />
    <div className="add-content-page">
      
      
    <form onSubmit={handleSubmit} id="dynamicAdd" noValidate>
    <>
        {/* ================= SECTION 1: BANNER ================= */}
        <div className="add-content-wrap">
            <h5>Section 1: Banner</h5>
            <div className="row">
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section1_title"}>
                                Title <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section1_title"
                            id={"section1_title"}
                            className="form-control"
                            value={postData.section1_title}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor="slug">
                                Slug<small>*</small>
                            </label>
                        </div>
                        <input
                            id="slug"
                            name="slug"
                            className="form-control"
                            value={postData.slug}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section1_description"}>
                                Description <small>*</small>
                            </label>
                        </div>
                        <DynamicCKEditor
                            data={postData.section1_description}
                            onChange={(event, editor) => handleEditorChange("section1_description", editor.getData())}
                        />
                    </div>
                </div>

                <div className="col-lg-12">
                    <div className="add-page-inputs input-add-image">
                        <div className="label-wrap-add">
                            <label htmlFor={"section1_image"}>
                                Image <small>*</small>
                            </label>
                        </div>
                        <CustomImageUpload
                            name={"section1_image"}
                            imagePreview={previews["section1_image"] || imagePreview(postData.section1_image)}
                            onImageChange={handleChange}
                            maxSize={5 * 1024 * 1024}
                            acceptedFormats={[".webp"]}
                        />
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section1_buttonText"}>Button Text </label>
                        </div>
                        <input
                            name="section1_buttonText"
                            id={"section1_buttonText"}
                            type="text"
                            className="form-control"
                            value={postData.section1_buttonText}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section1_imageAlt"}>
                                Image Alt <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section1_imageAlt"
                            id={"section1_imageAlt"}
                            type="text"
                            className="form-control"
                            value={postData.section1_imageAlt}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </div>

        {/* ================= SECTION 2: THE GAP ================= */}
        <div className="add-content-wrap">
            <h5>Section 2: The Gap</h5>
            <div className="row">
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section2_eyebrow"}>
                                Top Title <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section2_eyebrow"
                            id={"section2_eyebrow"}
                            type="text"
                            className="form-control"
                            value={postData.section2_eyebrow}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section2_title"}>
                                Title <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section2_title"
                            id={"section2_title"}
                            className="form-control"
                            value={postData.section2_title}
                            onChange={handleChange}
                            type="text"
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                {postData.section2_paragraphs.map((item, index) => (
                    <div
                        key={index}
                        className="col-lg-12"
                        style={{
                            position: "relative",
                        }}
                    >
                        <div className="add-page-inputs">
                            <div className="label-wrap-add">
                                <label htmlFor={`section2_paragraphs-${index}`}>
                                    Paragraph <small>*</small>
                                </label>
                            </div>
                            <DynamicCKEditor
                                data={item}
                                onChange={(event, editor) => handleSection2ParagraphsChange(index, editor.getData())}
                            />
                        </div>
                        <></>
                    </div>
                ))}
            </div>
            <h5 className="mt-3">FAQ Section</h5>
            <div className="row">
                {postData.section2_faqs.map((item, index) => (
                    <div
                        key={index}
                        className="col-lg-6"
                        style={{
                            position: "relative",
                        }}
                    >
                        <div className="add-page-inputs input-add-image">
                            <div className="label-wrap-add">
                                <label htmlFor={`section2_faqs-${index}-question`}>
                                    Question {(index < 3 || Object.values(item).some(isFilled)) && <small>*</small>}
                                </label>
                            </div>
                            <input
                                id={`section2_faqs-${index}-question`}
                                type="text"
                                className="form-control"
                                value={item.question}
                                onChange={(event) => handleSection2FaqsChange(index, "question", event.target.value)}
                            />
                        </div>
                        <div className="add-page-inputs input-add-image">
                            <div className="label-wrap-add">
                                <label htmlFor={`section2_faqs-${index}-answer`}>
                                    Answer {(index < 3 || Object.values(item).some(isFilled)) && <small>*</small>}
                                </label>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                value={item.answer}
                                onChange={(event) => handleSection2FaqsChange(index, "answer", event.target.value)}
                            />
                        </div>
                        <>
                            {index >= 3 && <button type="button" onClick={() => handleRemoveSection2Faqs(index)} className="remove-btn">
                                REMOVE
                            </button>}
                        </>
                    </div>
                ))}
                <div className="col-lg-12 text-center">
                    <div className="add-more-btn">
                        <button
                            type="button"
                            disabled={postData.section2_faqs.length >= 100}
                            onClick={handleAddMoreSection2Faqs}
                            className="add-faqs addmore-images-client"
                        >
                            Add More Faq
                        </button>
                    </div>
                </div>
            </div>
        </div>

        {/* ================= SECTION 3: CAMPUS TO CORPORATE ================= */}
        <div className="add-content-wrap">
            <h5>Section 3: Campus To Corporate</h5>
            <div className="row">
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor="section3_eyebrow">
                                Top Title <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section3_eyebrow"
                            id="section3_eyebrow"
                            type="text"
                            className="form-control"
                            value={postData.section3_eyebrow}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor="section3_title">
                                Title <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section3_title"
                            id="section3_title"
                            type="text"
                            className="form-control"
                            value={postData.section3_title}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor="section3_subtitle">
                                Subtitle <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section3_subtitle"
                            id="section3_subtitle"
                            type="text"
                            className="form-control"
                            value={postData.section3_subtitle}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor="section3_buttonText">
                                Button Text <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section3_buttonText"
                            id="section3_buttonText"
                            type="text"
                            className="form-control"
                            value={postData.section3_buttonText}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="add-page-inputs input-add-image">
                        <div className="label-wrap-add">
                            <label>
                                Image <small>*</small>
                            </label>
                        </div>
                        <CustomImageUpload
                            name="section3_image"
                            imagePreview={previews.section3_image || imagePreview(postData.section3_image)}
                            onImageChange={handleChange}
                            maxSize={5 * 1024 * 1024}
                            acceptedFormats={[".webp"]}
                        />
                    </div>
                </div>
            </div>
            <div className="row"></div>
            <h5 className="mt-3">Items</h5>
            <div className="row">
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor="section3_title1">
                                Title 1 <small>*</small>
                            </label>
                        </div>
                        <input
                            id="section3_title1"
                            name="section3_title1"
                            className="form-control"
                            type="text"
                            value={postData.section3_title1}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor="section3_description1">
                                Description 1 <small>*</small>
                            </label>
                        </div>
                        <textarea id="section3_description1" name="section3_description1" className="form-control" value={postData.section3_description1} onChange={handleChange} rows={4} style={{
  height: "auto"
}}></textarea>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor="section3_title2">
                                Title 2 <small>*</small>
                            </label>
                        </div>
                        <input
                            id="section3_title2"
                            name="section3_title2"
                            className="form-control"
                            type="text"
                            value={postData.section3_title2}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor="section3_description2">
                                Description 2 <small>*</small>
                            </label>
                        </div>
                        <textarea id="section3_description2" name="section3_description2" className="form-control" value={postData.section3_description2} onChange={handleChange} rows={4} style={{
  height: "auto"
}}></textarea>
                    </div>
                </div>
            </div>
        </div>

        {/* ================= SECTION 4: FRAMEWORK ================= */}
        <div className="add-content-wrap">
            <h5>Section 4: Framework</h5>
            <div className="row">
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section4_eyebrow"}>
                                Top title <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section4_eyebrow"
                            id={"section4_eyebrow"}
                            type="text"
                            className="form-control"
                            value={postData.section4_eyebrow}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section4_title"}>
                                Title <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section4_title"
                            id={"section4_title"}
                            className="form-control"
                            value={postData.section4_title}
                            onChange={handleChange}
                            type="text"
                        />
                    </div>
                </div>
            </div>
            <h5 className="mt-3">Steps</h5>
            <div className="row">
                {postData.section4_steps.map((item, index) => (
                    <div
                        key={index}
                        className="col-lg-4"
                        style={{
                            position: "relative",
                        }}
                    >
                        
                        <div className="add-page-inputs">
                            <div className="label-wrap-add">
                                <label htmlFor={`section4_steps-${index}-title`}>
                                    Title {(index < 6 || Object.values(item).some(isFilled)) && <small>*</small>}
                                </label>
                            </div>
                            <input
                                id={`section4_steps-${index}-title`}
                                className="form-control"
                                value={item.title}
                                onChange={(event) => handleSection4StepsChange(index, "title", event.target.value)}
                                type="text"
                            />
                        </div>
                        <div className="add-page-inputs">
                            <div className="label-wrap-add">
                                <label htmlFor={`section4_steps-${index}-description`}>
                                    Description {(index < 6 || Object.values(item).some(isFilled)) && <small>*</small>}
                                </label>
                            </div>
                            <textarea className="form-control" value={item.description} onChange={event => handleSection4StepsChange(index, "description", event.target.value)} rows={4} style={{
  height: "auto"
}}></textarea>
                        </div>
                        <>
                            {index >= 6 && <button type="button" onClick={() => handleRemoveSection4Steps(index)} className="remove-btn">
                                REMOVE
                            </button>}
                        </>
                    </div>
                ))}
                <div className="col-lg-12 text-center">
                    <div className="add-more-btn">
                        <button
                            type="button"
                            disabled={postData.section4_steps.length >= 100}
                            onClick={handleAddMoreSection4Steps}
                            className="add-faqs addmore-images-client"
                        >
                            Add More
                        </button>
                    </div>
                </div>
            </div>
        </div>

        {/* ================= SECTION 5: READINESS AREAS ================= */}
        <div className="add-content-wrap">
            <h5>Section 5: Readiness Areas</h5>
            <div className="row">
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section5_eyebrow"}>
                                Top Title <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section5_eyebrow"
                            id={"section5_eyebrow"}
                            type="text"
                            className="form-control"
                            value={postData.section5_eyebrow}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section5_title"}>
                                Title <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section5_title"
                            id={"section5_title"}
                            className="form-control"
                            value={postData.section5_title}
                            onChange={handleChange}
                            type="text"
                        />
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section5_description"}>
                                Description <small>*</small>
                            </label>
                        </div>
                        <textarea name="section5_description" id="section5_description" className="form-control" value={postData.section5_description} onChange={handleChange} rows={4} style={{
  height: "auto"
}}></textarea>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section5_buttonText"}>Button Text </label>
                        </div>
                        <input
                            name="section5_buttonText"
                            id={"section5_buttonText"}
                            type="text"
                            className="form-control"
                            value={postData.section5_buttonText}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            <h5 className="mt-3">Items</h5>
            <div className="row">
                {postData.section5_items.map((item, index) => (
                    <div
                        key={index}
                        className="col-lg-4"
                        style={{
                            position: "relative",
                        }}
                    >
                        <div className="add-page-inputs">
                            <div className="label-wrap-add">
                                <label htmlFor={`section5_items-${index}-title`}>
                                    Title {(index < 6 || Object.values(item).some(isFilled)) && <small>*</small>}
                                </label>
                            </div>
                            <input
                                id={`section5_items-${index}-title`}
                                className="form-control"
                                value={item.title}
                                onChange={(event) => handleSection5ItemsChange(index, "title", event.target.value)}
                                type="text"
                            />
                        </div>
                        <div className="add-page-inputs">
                            <div className="label-wrap-add">
                                <label htmlFor={`section5_items-${index}-description`}>
                                    Description {(index < 6 || Object.values(item).some(isFilled)) && <small>*</small>}
                                </label>
                            </div>
                            <textarea className="form-control" value={item.description} onChange={event => handleSection5ItemsChange(index, "description", event.target.value)} rows={4} style={{
  height: "auto"
}}></textarea>
                        </div>
                        <div className="add-page-inputs">
                            <div className="label-wrap-add">
                                <label htmlFor={`section5_items-${index}-skills`}>
                                    Skills {(index < 6 || Object.values(item).some(isFilled)) && <small>*</small>}
                                </label>
                            </div>
                            <textarea
                                id={`section5_items-${index}-skills`}
                                className="form-control"
                                rows={3}
                                style={{
                                    height: "auto",
                                }}
                                value={item.skills.join("\n")}
                                onChange={(event) =>
                                    handleSection5ItemsChange(index, "skills", event.target.value.split("\n"))
                                }
                                placeholder="One skill per line"
                            />
                        </div>
                        <>
                            {index >= 6 && <button type="button" onClick={() => handleRemoveSection5Items(index)} className="remove-btn">
                                REMOVE
                            </button>}
                        </>
                    </div>
                ))}
                <div className="col-lg-12 text-center">
                    <div className="add-more-btn">
                        <button
                            type="button"
                            disabled={postData.section5_items.length >= 100}
                            onClick={handleAddMoreSection5Items}
                            className="add-faqs addmore-images-client"
                        >
                            Add More
                        </button>
                    </div>
                </div>
            </div>
        </div>

        {/* ================= SECTION 6: TESTIMONIALS ================= */}
        <div className="add-content-wrap">
            <h5>Section 6: Testimonials</h5>
            <div className="row">
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section6_eyebrow"}>
                                Top Title <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section6_eyebrow"
                            id={"section6_eyebrow"}
                            type="text"
                            className="form-control"
                            value={postData.section6_eyebrow}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section6_title"}>
                                Title <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section6_title"
                            id={"section6_title"}
                            className="form-control"
                            value={postData.section6_title}
                            onChange={handleChange}
                            type="text"
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                {postData.section6_items.map((item, index) => (
                    <div
                        key={index}
                        className="col-lg-4"
                        style={{
                            position: "relative",
                        }}
                    >
                        <div className="add-page-inputs">
                            <div className="label-wrap-add">
                                <label htmlFor={`section6_items-${index}-content`}>
                                    Testimonial Content <small>*</small>
                                </label>
                            </div>
                            <DynamicCKEditor
                                data={item.content}
                                onChange={(event, editor) =>
                                    handleSection6ItemsChange(index, "content", editor.getData())
                                }
                            />
                        </div>
                        <div className="add-page-inputs">
                            <div className="label-wrap-add">
                                <label htmlFor={`section6_items-${index}-authorName`}>
                                    Author Name <small>*</small>
                                </label>
                            </div>
                            <input
                                id={`section6_items-${index}-authorName`}
                                type="text"
                                className="form-control"
                                value={item.authorName}
                                onChange={(event) => handleSection6ItemsChange(index, "authorName", event.target.value)}
                            />
                        </div>
                        <div className="add-page-inputs">
                            <div className="label-wrap-add">
                                <label htmlFor={`section6_items-${index}-authorDesignation`}>
                                    Author Designation <small>*</small>
                                </label>
                            </div>
                            <input
                                id={`section6_items-${index}-authorDesignation`}
                                type="text"
                                className="form-control"
                                value={item.authorDesignation}
                                onChange={(event) =>
                                    handleSection6ItemsChange(index, "authorDesignation", event.target.value)
                                }
                            />
                        </div>

                        <>
                            <button
                                type="button"
                                onClick={() => handleRemoveSection6Items(index)}
                                className="remove-btn"
                            >
                                REMOVE
                            </button>
                        </>
                    </div>
                ))}
                <div className="col-lg-12 text-center">
                    <div className="add-more-btn">
                        <button
                            type="button"
                            disabled={postData.section6_items.length >= 100}
                            onClick={handleAddMoreSection6Items}
                            className="add-faqs addmore-images-client"
                        >
                            Add More
                        </button>
                    </div>
                </div>
            </div>
        </div>

        {/* ================= SECTION 7: CALL TO ACTION ================= */}
        <div className="add-content-wrap">
            <h5>Section 7: Call To Action</h5>
            <div className="row">
                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section7_title"}>
                                Title <small>*</small>
                            </label>
                        </div>
                        <input
                            name="section7_title"
                            id={"section7_title"}
                            className="form-control"
                            value={postData.section7_title}
                            onChange={handleChange}
                            type="text"
                        />
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="add-page-inputs">
                        <div className="label-wrap-add">
                            <label htmlFor={"section7_button"}>Button Text </label>
                        </div>
                        <input
                            name="section7_button"
                            id={"section7_button"}
                            type="text"
                            className="form-control"
                            value={postData.section7_button}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="add-page-inputs input-add-image">
                        <div className="label-wrap-add">
                            <label htmlFor={"section7_backgroundImage"}>
                                Background Image <small>*</small>
                            </label>
                        </div>
                        <CustomImageUpload
                            name={"section7_backgroundImage"}
                            imagePreview={
                                previews["section7_backgroundImage"] || imagePreview(postData.section7_backgroundImage)
                            }
                            onImageChange={handleChange}
                            maxSize={5 * 1024 * 1024}
                            acceptedFormats={[".webp"]}
                        />
                    </div>
                </div>
            </div>
        </div>

        {/* ================= SECTION 8: FAQS ================= */}
        
    </>
</form>

      
    <button type="submit" className="default-btn" form="dynamicAdd" disabled={saving}>{saving ? "Saving..." : "Publish"}<span></span></button></div>
  </>
}
